<div class="login-container">
  <!-- Left side - Background -->
  <div class="login-left">
  </div>
  
  <!-- Right side - Login Form -->
  <div class="login-right">
    <div class="login-form-container">
      <div class="form-branding">
        <img src="/images/DSDN_Images/desimonelogoblack.png" alt="DeSimone" style="display:block;margin:0 auto 18px auto;max-width:220px;width:100%;height:auto;">
       <h1 class="login-titleh1">STRUCTURAL<br>DETAILER<br>NETWORK</h1>
      </div>
      <h2 class="login-title">Sign In</h2>

      <div *ngIf="error" class="error-message">
        {{ error }}
      </div>

      <form (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="username">Username</label>
          <input 
            type="text" 
            id="username" 
            class="form-control" 
            name="username" 
            [(ngModel)]="loginRequest.username" 
            required 
            autofocus
            autocomplete="username"
          >
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input 
            type="password" 
            id="password" 
            class="form-control" 
            name="password" 
            [(ngModel)]="loginRequest.password" 
            required
            autocomplete="current-password"
          >
        </div>

        <button 
          type="submit" 
          class="btn btn-primary" 
          [disabled]="loading"
        >
          <div *ngIf="loading" class="spinner"></div>
          <span>{{ loading ? 'Signing in...' : 'Sign In' }}</span>
        </button>
      </form>

      <div *ngIf="showMicrosoftSignIn" class="sso-section">
        <div class="sso-divider"><span>or</span></div>
        <button
          type="button"
          class="btn btn-microsoft"
          [disabled]="ssoLoading || processingMicrosoftRedirect"
          (click)="signInWithMicrosoft()"
        >
          <span *ngIf="ssoLoading || processingMicrosoftRedirect" class="spinner"></span>
          <span *ngIf="!ssoLoading && !processingMicrosoftRedirect" class="microsoft-mark" aria-hidden="true">
            <i></i><i></i><i></i><i></i>
          </span>
          <span>
            {{ ssoLoading || processingMicrosoftRedirect ? 'Connecting to Microsoft...' : 'Sign in with Microsoft' }}
          </span>
        </button>
        <p class="sso-hint">Use your DeSimone work account</p>
      </div>

      <!-- Forgot Password Section -->
      <div class="forgot-password-section">
        <div *ngIf="checkingEmail" class="checking-email">
          <div class="mini-spinner"></div>
          <span>Checking...</span>
        </div>
        
        <a 
          *ngIf="showForgotPassword && !checkingEmail" 
          (click)="goToForgotPassword()" 
          class="forgot-password-link"
        >
          Forgot Password?
        </a>
        
        <p *ngIf="error && !showForgotPassword && !checkingEmail" class="no-email-message">
          Contact your administrator to reset your password
        </p>
      </div>
    </div>
  </div>
</div>
